<template>
  <div>
    <div class="card-body-2">
        <div style="flex: 1;"></div>
        <div class="card-body-2-data">
          <span class="card-body-2-data-text card-header-text">Long: &nbsp; &nbsp; &nbsp;</span>
          <span class="card-body-2-data-text"> {{ longitude }}</span>
        </div>
        <div class="card-body-2-data">
          <span class="card-body-2-data-text card-header-text">Lat: &nbsp; &nbsp; &nbsp;</span>
          <span class="card-body-2-data-text"> {{ latitude }}</span>
        </div>
        <div class="card-body-2-buttons-container">
          <span class="button-standard" v-on:click="accept">Accept</span>       
          <span class="button-standard" v-on:click="cancel">Cancel</span> 
        </div>      
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from "vuex";

export default {
  name: 'inputMap',
  computed: {
    ...mapGetters({
      status: 'ui/status', 
      current_interface: 'ui/current_interface',
      longitude: 'dsptool/longitude',
      latitude: 'dsptool/latitude',
    })
  },
  data() {
    return {
      temp_long: null,
      temp_lat: null,
    }
  },
  created () {

  },
  mounted () {
    this.temp_long = this.longitude
    this.temp_lat = this.latitude
  },
  methods: {
    accept: function () {
      this.temp_long = null
      this.temp_lat = null
      // ESTE DISPATCH DEVUELVE AL PASO 2 (LOCALIZACIÓN)
      this.$store.dispatch('ui/change_current_interface', 2)
    },
    cancel: function () {
      this.$store.dispatch('dsptool/change_longitude', this.temp_long)
      this.$store.dispatch('dsptool/change_latitude', this.temp_lat)
      // ESTE DISPATCH DEVUELVE AL PASO 2 (LOCALIZACIÓN)
      this.$store.dispatch('ui/change_current_interface', 2)
    }
  }
}
</script>